import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@tanstack/react-query';
import GoogleMapsLoader from '@/components/entities/utils/google-maps-loader';
const useStreetViewPanorama = (coordinates, streetViewRef) => {
  const $ = _c(10);
  const t0 = coordinates?.latitude;
  const t1 = coordinates?.longitude;
  let t2;
  if ($[0] !== t0 || $[1] !== t1) {
    t2 = ["streetView", t0, t1];
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== coordinates || $[4] !== streetViewRef) {
    t3 = async () => {
      if (!coordinates) {
        throw new Error("Coordinates are required to load the Street View panorama");
      }
      await GoogleMapsLoader.importLibrary("core");
      const {
        data
      } = await new google.maps.StreetViewService().getPanorama({
        location: {
          lat: coordinates.latitude,
          lng: coordinates.longitude
        },
        radius: 50
      });
      return new google.maps.StreetViewPanorama(streetViewRef.current as HTMLElement, {
        pano: data?.location?.pano,
        pov: {
          heading: 165,
          pitch: 0
        },
        zoom: 1,
        disableDefaultUI: true
      });
    };
    $[3] = coordinates;
    $[4] = streetViewRef;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const t4 = !!coordinates;
  let t5;
  if ($[6] !== t2 || $[7] !== t3 || $[8] !== t4) {
    t5 = {
      queryKey: t2,
      queryFn: t3,
      enabled: t4
    };
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return useQuery(t5);
};
export default useStreetViewPanorama;